<h1 mat-dialog-title>LC SSO error</h1>
<div style="display:inline-block" mat-dialog-content>
  We've detected an error with the SSO for your First Connect account. Our team has been notified.
</div>
<div mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Close</button>
</div>